import {AnyAction} from "redux";

export const SET_PLAN = "SET_PLAN";

const initialState = {
    plan: null,
}

export const planReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case SET_PLAN: return { ...state,
            plan: action.payload
        }
        default: return state
    }
}